import { render } from "./DiscountItem.vue?vue&type=template&id=2bbb6e83"
import script from "./DiscountItem.vue?vue&type=script&lang=js"
export * from "./DiscountItem.vue?vue&type=script&lang=js"

import "./DiscountItem.vue?vue&type=style&index=0&id=2bbb6e83&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__